/** 1,5 GiB — mantener alineado con `MAX_UPLOAD_FILE_SIZE` en nrdeal-backend (file.constants.js). */
export const MAX_FILE_UPLOAD_BYTES = Math.floor(1.5 * 1024 * 1024 * 1024);
